import { render, staticRenderFns } from "./PinBoldIcon.vue?vue&type=template&id=56576c33&scoped=true&"
import script from "./PinBoldIcon.vue?vue&type=script&lang=js&"
export * from "./PinBoldIcon.vue?vue&type=script&lang=js&"
import style0 from "./PinBoldIcon.vue?vue&type=style&index=0&id=56576c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56576c33",
  null
  
)

export default component.exports